// Module
var code = "<div id=\"V-F05C35EC-2E6E-428F-9B7F-2B80F21CB875\"> <div class=\"center-vertically\"> <select class=\"select\" data-b-attr-tabindex=\"{Binding tabindex}\"> <option id=\"optionId\" style=\"display:none\" hidden disabled=\"disabled\" selected=\"selected\" value></option> </select> </div> </div> ";
// Exports
export default code;